import axios, { AxiosResponse } from 'axios';

export const fetcher = (url: string, token?: string) =>
  axios
    .get(url, {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        'Content-Type': 'application/json',
      },
    })
    .then((response: AxiosResponse) => response.data);
